<template>
  <v-alert
    :class="{
      'e-alarm': true,
      'e-alarm__clickable': clickable,
    }"
    :color="color"
    :text="text"
    v-bind="$attrs"
    @click.prevent="clickAction"
  >
    <slot v-if="icon || $slots.prepend" name="prepend" slot="prepend">
      <e-icon class="e-alarm__icon" :size="iconSize">{{ icon }}</e-icon>
    </slot>
    <slot>
      <div class="e-alarm__content">
        <div class="e-alarm__title">{{ title }}</div>
        <div class="e-alarm__counter">
          <div v-if="counterNumber !== null" class="e-alarm__counter-number">{{ counterNumber }}</div>
          <div v-if="counterSubNumber !== null" class="e-alarm__counter-sub-number">{{ counterSubNumber }}</div>
        </div>
      </div>
    </slot>
  </v-alert>
</template>

<script>
import { EIcon } from '../vuetify'
import { VAlert } from 'vuetify/lib/components'

export default {
  name: 'EAlarm',
  components: {
    VAlert,
    EIcon,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    counterNumber: {
      type: [Number, String],
      default: null,
    },

    counterSubNumber: {
      type: [Number, String],
      default: null,
    },

    color: {
      type: String,
      default: 'primary',
    },

    text: {
      type: Boolean,
      default: true,
    },

    icon: {
      type: String,
      default: undefined,
    },

    iconSize: {
      type: Number,
      default: 16,
    },

    clickable: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    clickAction(event) {
      if (this.clickable) this.$emit('click', event)
    },
  },
}
</script>
